/** Intra-block line alignment for multi-line text */
export type TextAlign = 'left' | 'center' | 'right' | 'justify'

export interface ScreenText {
  id: string
  text: string
  fontFamily: string
  /** Font size in px (relative to 1024-wide canvas) */
  fontSize: number
  color: string
  bold: boolean
  italic: boolean
  /** Intra-block line alignment; the block stays anchored at (x,y).
   *  Optional — configs saved before the field existed fall back to 'center'. */
  align?: TextAlign
  /** Normalized 0..1 horizontal position (0 = left) */
  x: number
  /** Normalized 0..1 vertical position (0 = top) */
  y: number
  /** Rotation in degrees */
  rotation: number
}

// IDs use `crypto.randomUUID()` — see comment in spriteTypes.ts for the rationale
// (module-level counter collides with saved IDs after a fresh page load).
export const generateTextId = (): string => `text-${crypto.randomUUID()}`

/** Available locally-bundled fonts (generated by scripts/convert-fonts.mjs) */
export const FONT_OPTIONS = [
  'Roboto',
  'Open Sans',
  'Google Sans',
  'Inter',
  'Roboto Condensed',
  'Arimo',
  'Noto Sans',
  'Ubuntu',
  'Fira Sans',
  'Noto Serif',
  'Source Sans 3',
  'Source Code Pro',
  'EB Garamond',
  'Inter Tight',
  'Fira Sans Condensed',
  'Alegreya',
  'Alegreya Sans',
  'Literata',
  'Noto Sans Display',
  'Noto Serif Display',
  'Fira Sans Extra Condensed',
  'Alegreya Sans SC',
  'Ubuntu Sans',
  'Alegreya SC',
  'Piazzolla',
  'Iosevka Charon',
  'Ubuntu Sans Mono',
  'Iosevka Charon Mono',
  'Nokia Cellphone FC',
] as const

/** Create a new screen text with defaults */
export const createScreenText = (text: string = 'Your Text'): ScreenText => ({
  id: generateTextId(),
  text,
  fontFamily: 'Inter',
  fontSize: 48,
  color: '#ffffff',
  bold: true,
  italic: false,
  align: 'center',
  x: 0.5,
  y: 0.5,
  rotation: 0,
})
